import React from 'react';
import { createRoot } from 'react-dom/client';
import { LocalizationContextBuilder } from '@amzn/arb-tools';
import Loader from '@amzn/meridian/loader';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import App from 'src/components/App';
import {
  ArbBundleProvider,
  DEFAULT_LOCALE,
  resolveBundleUrlWithFallbacks,
} from 'src/arb-wrapper';
import { Provider } from 'react-redux';
import { store } from 'src/store';
import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import 'src/index.scss';
import { ToasterProvider } from 'src/components/common/alerts/ToasterContext';
import { UserProvider } from 'src/contexts/UserContext';
import { ChatPanelProvider } from 'src/contexts/ChatPanelContext';

const mbmOptions = {
  arbManifest,
  defaultLocalizationContext: new LocalizationContextBuilder()
    .withLocale(DEFAULT_LOCALE)
    .withDefaultLocale(DEFAULT_LOCALE)
    .build(),
  resolveBundleUrl: (
    resourcePackPath: string | undefined,
    locale: string,
    bundle: string
  ) => resolveBundleUrlWithFallbacks(resourcePackPath, locale, bundle),
};

const AppLoader: React.FC = () => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: '100vh',
    }}
  >
    <Loader size="large" />
  </div>
);

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<AppLoader />}>
      <MbmProvider {...mbmOptions}>
        <ArbBundleProvider fallback={<AppLoader />}>
          <Provider store={store}>
            <UserProvider>
            <ChatPanelProvider>
            <ToasterProvider>
              <App />
            </ToasterProvider>
            </ChatPanelProvider>
            </UserProvider>
          </Provider>
        </ArbBundleProvider>
      </MbmProvider>
    </React.Suspense>
  </React.StrictMode>
);
